import { Component, Input, OnInit } from '@angular/core';
import { ESigningMethod } from '@literax/enums/document.enum';

import { EIdentityValidationType } from '@literax/enums/official-identification.enum';
import { IViewSignRequest } from '@literax/models/document.model';
import { ISignaturesResponse } from '@literax/models/http/api/signature.model';

import { UntilDestroy } from '@ngneat/until-destroy';
@UntilDestroy()
@Component({
  selector: 'literax-signature',
  templateUrl: './signature.component.html',
  styleUrls: ['./signature.component.scss'],
})
export class SignatureComponent implements OnInit {
  @Input() digital: boolean;
  @Input() viewSignature: IViewSignRequest; //v3
  @Input() document;
  @Input() signature: ISignaturesResponse;
  @Input() twoFactorAuth: boolean;

  

  signingMethods = ESigningMethod;
  isVisible = false;
  isHaveIdRequest= true;

  public get identityValidationType(): typeof EIdentityValidationType {
    return EIdentityValidationType;
  }

  ngOnInit() {
    if((this.viewSignature.idDocumentRequestInfo === null || this.viewSignature.idDocumentRequestInfo.idImageBase64 === null) && (!this.signature?.id_image_url)) {
      this.isHaveIdRequest = false;
    }
  }

  showModal(): void {
    this.isVisible = true;
  }

  handleOk(): void {
    this.isVisible = false;
  }
  handleCancel(): void {
    this.isVisible = false;
  }
}
